export const messageHistoryCopyEnUs = {
    title: "Message History",
    noMessages: "No messages found",
    viewMessages: "View messages",
    to: "To:",
    from: "From:",
    subject: "Subject:",
    statusClicked: "Clicked",
    statusRead: "Read",
    statusReadAt: "at",
    statusDelivered: "Delivered",
    statusSent: "Sent",
    statusPending: "Pending",
    channelEmail: "Email",
    channelSms: "SMS",
    retentionNotice: "Messages are only retained for 30 days",
};
